import { render, staticRenderFns } from "./resource-form.vue?vue&type=template&id=5669a196&"
import script from "./resource-form.vue?vue&type=script&lang=js&"
export * from "./resource-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports